import { useMutation } from '@tanstack/react-query';

import { fetchJson } from '../fetch';

type Payload = {
  accountantEmailAddress: string;
  userEmailAddress: string;
};

export const useLinkAccountant = () => {
  return useMutation({
    mutationFn: (body: Payload) => {
      return fetchJson('/registration/link-accountant', {
        method: 'POST',
        body,
      });
    },
  });
};
